// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 954) return "subsite-china/954-044492de97a55ae1d3cc.js";
	if (chunkId === 532) return "subsite-china/styles-4eaeceb620afdd1ebc91.js";
	if (chunkId === 351) return "subsite-china/commons-85552c31f3cdf5fc9fa3.js";
	if (chunkId === 875) return "subsite-china/190f48e1d712abf1b23afe7d98d0424ba15cabee-4e9b82f11bf58c1bbda0.js";
	if (chunkId === 218) return "subsite-china/component---src-pages-404-tsx-98aacec377c341c8e9fc.js";
	if (chunkId === 278) return "subsite-china/b0c88c5e5b54854a066ab8be45f25781c5307858-aa303c119b43009c9a56.js";
	if (chunkId === 904) return "subsite-china/2d1c9d34d7cabdcdf27eb8ffad16bade3b93f9b1-a68d2a5d6c235981e3f4.js";
	if (chunkId === 660) return "subsite-china/component---src-templates-personal-area-calendar-page-index-tsx-ccc559bb4c04d2441914.js";
	if (chunkId === 456) return "subsite-china/8bd7444894d603c816394f87921cda61ce72b74b-63fcdb1e3634d436b98b.js";
	if (chunkId === 874) return "subsite-china/component---src-templates-personal-area-profile-page-index-tsx-e35728f880678c0f62db.js";
	if (chunkId === 323) return "subsite-china/component---src-templates-qr-index-tsx-53b51d0abc2451136d40.js";
	if (chunkId === 77) return "subsite-china/component---src-templates-search-page-index-tsx-cb43211c2b37bc7c79c3.js";
	if (chunkId === 737) return "subsite-china/fb7d5399-9fbf16acb918fafc71af.js";
	if (chunkId === 863) return "subsite-china/072d4843-bc4214886b72bc7a6b93.js";
	if (chunkId === 208) return "subsite-china/2aacc723-9f6e5e234453322e2e09.js";
	if (chunkId === 344) return "subsite-china/bf322c48-841219717777a3dfa170.js";
	if (chunkId === 811) return "subsite-china/22e32791-e7596aea5ce66d9cc052.js";
	if (chunkId === 312) return "subsite-china/409a021e-cb15e1812abacfcd94dc.js";
	if (chunkId === 125) return "subsite-china/b2d36f25-2d5ff023047f12c7a077.js";
	if (chunkId === 255) return "subsite-china/7d0bf13e-0603809da70a985d3cc3.js";
	if (chunkId === 330) return "subsite-china/component---src-templates-standard-page-index-tsx-f22aab1fda1c2ea23585.js";
	if (chunkId === 731) return "subsite-china/731-1f561802ecd0bc720574.js";
	if (chunkId === 843) return "subsite-china/843-6cd0567895737b685652.js";
	// return url for filenames based on template
	return undefined;
};